import React from 'react'
import { useLocation } from 'react-router-dom'

import Header from '../header'
import AsyncNavigationFooter from '../../../../layouts/shared-navigation/navigation-footer'
import UseNotFoundProvider from '../../../../components/not-found/hooks/use-not-found-context'
import UseItemAnimationProvider from '../../hooks/use-item-animation'

import { useStyles } from './layout.styles'

const Layout = ({ children }) => {
  const styles = useStyles()
  const location = useLocation()

  return (
    <UseNotFoundProvider>
      <UseItemAnimationProvider>
        <div className={styles.layout}>
          <Header />

          <div className={styles.content}>{children}</div>

          <AsyncNavigationFooter
            location={location}
            className={styles.footer}
          />
        </div>
      </UseItemAnimationProvider>
    </UseNotFoundProvider>
  )
}

export default Layout
